export default __webpack_public_path__ + "static/media/red-mountain.e9e5234d.jpg";